module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "main_main_contents"
  }, [_vm._m(0), _c('div', {
    staticClass: "x_panel"
  }, [_c('div', {
    staticClass: "x_content"
  }, [_c('table', {
    staticClass: "agreementtable"
  }, [_c('tbody', [_c('tr', {
    staticClass: "form-group"
  }, [_vm._m(1), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.group_id),
      expression: "group_id"
    }],
    staticClass: "form-control agreementchange",
    class: {
      invalid: _vm.$v.group_id.$dirty && _vm.$v.group_id.$invalid
    },
    attrs: {
      "id": "group_id",
      "type": "text"
    },
    domProps: {
      "value": (_vm.group_id)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.group_id = $event.target.value
      }, _vm.$v.group_id.$touch]
    }
  }), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.$v.group_id.$dirty && _vm.$v.group_id.$invalid),
      expression: "$v.group_id.$dirty && $v.group_id.$invalid"
    }],
    staticClass: "error"
  }, [_c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.$v.group_id.required),
      expression: "!$v.group_id.required"
    }]
  }, [_vm._v("必須項目です")]), _c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.$v.group_id.maxLength),
      expression: "!$v.group_id.maxLength"
    }]
  }, [_vm._v("20文字以下で入力してください")])])])]), _c('tr', {
    staticClass: "form-group"
  }, [_vm._m(2), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.contractor_name),
      expression: "contractor_name"
    }],
    staticClass: "form-control agreementchange",
    class: {
      invalid: _vm.$v.contractor_name.$dirty && _vm.$v.contractor_name.$invalid
    },
    attrs: {
      "id": "contractor_name",
      "type": "text"
    },
    domProps: {
      "value": (_vm.contractor_name)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.contractor_name = $event.target.value
      }, _vm.$v.contractor_name.$touch]
    }
  }), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.$v.contractor_name.$dirty && _vm.$v.contractor_name.$invalid),
      expression: "$v.contractor_name.$dirty && $v.contractor_name.$invalid"
    }],
    staticClass: "error"
  }, [_c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.$v.contractor_name.required),
      expression: "!$v.contractor_name.required"
    }]
  }, [_vm._v("必須項目です")]), _c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.$v.contractor_name.maxLength),
      expression: "!$v.contractor_name.maxLength"
    }]
  }, [_vm._v("20文字以下で入力してください")])])])]), _c('tr', {
    staticClass: "form-group"
  }, [_vm._m(3), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.contractor_kana),
      expression: "contractor_kana"
    }],
    staticClass: "form-control agreementchange",
    class: {
      invalid: _vm.$v.contractor_kana.$dirty && _vm.$v.contractor_kana.$invalid
    },
    attrs: {
      "id": "contractor_kana",
      "type": "text"
    },
    domProps: {
      "value": (_vm.contractor_kana)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.contractor_kana = $event.target.value
      }, _vm.$v.contractor_kana.$touch]
    }
  }), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.$v.contractor_kana.$dirty && _vm.$v.contractor_kana.$invalid),
      expression: "$v.contractor_kana.$dirty && $v.contractor_kana.$invalid"
    }],
    staticClass: "error"
  }, [_c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.$v.contractor_kana.required),
      expression: "!$v.contractor_kana.required"
    }]
  }, [_vm._v("必須項目です")]), _c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.$v.contractor_kana.maxLength),
      expression: "!$v.contractor_kana.maxLength"
    }]
  }, [_vm._v("20文字以下で入力してください")]), _c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.$v.contractor_kana.kana),
      expression: "!$v.contractor_kana.kana"
    }]
  }, [_vm._v("全角カナで入力してください")])])])]), _c('tr', {
    staticClass: "form-group"
  }, [_vm._m(4), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.zip_code),
      expression: "zip_code"
    }],
    staticClass: "form-control agreementchange",
    class: {
      invalid: _vm.$v.zip_code.$dirty && _vm.$v.zip_code.$invalid
    },
    attrs: {
      "id": "zip_code",
      "type": "text"
    },
    domProps: {
      "value": (_vm.zip_code)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.zip_code = $event.target.value
      }, _vm.$v.zip_code.$touch]
    }
  }), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.$v.zip_code.$dirty && _vm.$v.zip_code.$invalid),
      expression: "$v.zip_code.$dirty && $v.zip_code.$invalid"
    }],
    staticClass: "error"
  }, [_c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.$v.zip_code.required),
      expression: "!$v.zip_code.required"
    }]
  }, [_vm._v("必須項目です")]), _c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.$v.zip_code.maxLength),
      expression: "!$v.zip_code.maxLength"
    }]
  }, [_vm._v("8文字以下で入力してください")])])])]), _c('tr', {
    staticClass: "form-group"
  }, [_vm._m(5), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.pref),
      expression: "pref"
    }],
    staticClass: "form-control agreementchange",
    class: {
      invalid: _vm.$v.pref.$dirty && _vm.$v.pref.$invalid
    },
    attrs: {
      "id": "pref",
      "type": "text"
    },
    domProps: {
      "value": (_vm.pref)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.pref = $event.target.value
      }, _vm.$v.pref.$touch]
    }
  }), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.$v.pref.$dirty && _vm.$v.pref.$invalid),
      expression: "$v.pref.$dirty && $v.pref.$invalid"
    }],
    staticClass: "error"
  }, [_c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.$v.pref.required),
      expression: "!$v.pref.required"
    }]
  }, [_vm._v("必須項目です")]), _c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.$v.pref.maxLength),
      expression: "!$v.pref.maxLength"
    }]
  }, [_vm._v("10文字以下で入力してください")])])])]), _c('tr', {
    staticClass: "form-group"
  }, [_vm._m(6), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.city),
      expression: "city"
    }],
    staticClass: "form-control agreementchange",
    class: {
      invalid: _vm.$v.city.$dirty && _vm.$v.city.$invalid
    },
    attrs: {
      "id": "city",
      "type": "text"
    },
    domProps: {
      "value": (_vm.city)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.city = $event.target.value
      }, _vm.$v.city.$touch]
    }
  }), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.$v.city.$dirty && _vm.$v.city.$invalid),
      expression: "$v.city.$dirty && $v.city.$invalid"
    }],
    staticClass: "error"
  }, [_c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.$v.city.required),
      expression: "!$v.city.required"
    }]
  }, [_vm._v("必須項目です")]), _c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.$v.city.maxLength),
      expression: "!$v.city.maxLength"
    }]
  }, [_vm._v("20文字以下で入力してください")])])])]), _c('tr', {
    staticClass: "form-group"
  }, [_vm._m(7), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.address1),
      expression: "address1"
    }],
    staticClass: "form-control agreementchange",
    class: {
      invalid: _vm.$v.address1.$dirty && _vm.$v.address1.$invalid
    },
    attrs: {
      "id": "address1",
      "type": "text"
    },
    domProps: {
      "value": (_vm.address1)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.address1 = $event.target.value
      }, _vm.$v.address1.$touch]
    }
  }), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.$v.address1.$dirty && _vm.$v.address1.$invalid),
      expression: "$v.address1.$dirty && $v.address1.$invalid"
    }],
    staticClass: "error"
  }, [_c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.$v.address1.required),
      expression: "!$v.address1.required"
    }]
  }, [_vm._v("必須項目です")]), _c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.$v.address1.maxLength),
      expression: "!$v.address1.maxLength"
    }]
  }, [_vm._v("50文字以下で入力してください")])])])]), _c('tr', {
    staticClass: "form-group"
  }, [_vm._m(8), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.address2),
      expression: "address2"
    }],
    staticClass: "form-control agreementchange",
    class: {
      invalid: _vm.$v.address2.$invalid
    },
    attrs: {
      "id": "address2",
      "type": "text"
    },
    domProps: {
      "value": (_vm.address2)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.address2 = $event.target.value
      }
    }
  }), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.$v.address2.$dirty && _vm.$v.address2.$invalid),
      expression: "$v.address2.$dirty && $v.address2.$invalid"
    }],
    staticClass: "error"
  }, [_c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.$v.address2.maxLength),
      expression: "!$v.address2.maxLength"
    }]
  }, [_vm._v("50文字以下で入力してください")])])])]), _c('tr', {
    staticClass: "form-group"
  }, [_vm._m(9), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.mail),
      expression: "mail"
    }],
    staticClass: "form-control agreementchange",
    class: {
      invalid: _vm.$v.mail.$dirty && _vm.$v.mail.$invalid
    },
    attrs: {
      "id": "mail",
      "type": "text"
    },
    domProps: {
      "value": (_vm.mail)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.mail = $event.target.value
      }, _vm.$v.mail.$touch]
    }
  }), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.$v.mail.$dirty && _vm.$v.mail.$invalid),
      expression: "$v.mail.$dirty && $v.mail.$invalid"
    }],
    staticClass: "error"
  }, [_c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.$v.mail.required),
      expression: "!$v.mail.required"
    }]
  }, [_vm._v("必須項目です")]), _c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.$v.mail.maxLength),
      expression: "!$v.mail.maxLength"
    }]
  }, [_vm._v("50文字以下で入力してください")]), _c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.$v.mail.email),
      expression: "!$v.mail.email"
    }]
  }, [_vm._v("不正なメールアドレスです")])])])]), _c('tr', {
    staticClass: "form-group"
  }, [_vm._m(10), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.tel),
      expression: "tel"
    }],
    staticClass: "form-control agreementchange",
    class: {
      invalid: _vm.$v.tel.$dirty && _vm.$v.tel.$invalid
    },
    attrs: {
      "id": "tel",
      "type": "text"
    },
    domProps: {
      "value": (_vm.tel)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.tel = $event.target.value
      }, _vm.$v.tel.$touch]
    }
  }), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.$v.tel.$dirty && _vm.$v.tel.$invalid),
      expression: "$v.tel.$dirty && $v.tel.$invalid"
    }],
    staticClass: "error"
  }, [_c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.$v.tel.required),
      expression: "!$v.tel.required"
    }]
  }, [_vm._v("必須項目です")]), _c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.$v.tel.maxLength),
      expression: "!$v.tel.maxLength"
    }]
  }, [_vm._v("20文字以下で入力してください")])])])]), _c('tr', {
    staticClass: "form-group"
  }, [_vm._m(11), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.fax),
      expression: "fax"
    }],
    staticClass: "form-control agreementchange",
    class: {
      invalid: _vm.$v.fax.$invalid
    },
    attrs: {
      "id": "fax",
      "type": "text"
    },
    domProps: {
      "value": (_vm.fax)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.fax = $event.target.value
      }
    }
  }), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.$v.fax.$invalid),
      expression: "$v.fax.$invalid"
    }],
    staticClass: "error"
  }, [_c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.$v.fax.maxLength),
      expression: "!$v.fax.maxLength"
    }]
  }, [_vm._v("20文字以下で入力してください")])])])]), _c('tr', [_vm._m(12), _c('td', [_c('span', [_vm._v(_vm._s(_vm._f("plan_name")(_vm.plan)) + " / " + _vm._s(_vm._f("payment_plan_name")(_vm.payment_plan)))]), _c('a', {
    attrs: {
      "href": "http://startup.racooo.com/plan_change",
      "type": "button"
    }
  }, [_vm._v("契約プラン及び支払い方法の変更はこちら")])])]), _c('tr', [_vm._m(13), _c('td', [_vm._v(_vm._s(_vm.contract_start_date))])]), _c('tr', [_vm._m(14), _c('td', [_vm._v(_vm._s(_vm.expiration_date))])])])])]), _c('button', {
    staticClass: "customsmallbutton btn btn-success",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.update
    }
  }, [_vm._v("更新")]), _vm._m(15), _c('a', {
    staticClass: "customsmallbutton btn btn-primary",
    attrs: {
      "href": "http://startup.racooo.com/inquiry",
      "type": "button"
    }
  }, [_vm._v("お問い合わせはこちら")])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page-title"
  }, [_c('div', {
    staticClass: "title_left"
  }, [_c('h2', [_vm._v("登録・契約情報")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('th', [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": "group_id"
    }
  }, [_vm._v("グループID")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('th', [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": "contractor_name"
    }
  }, [_vm._v("契約者名")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('th', [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": "contractor_kana"
    }
  }, [_vm._v("フリガナ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('th', [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": "zip_code"
    }
  }, [_vm._v("住所 郵便番号")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('th', [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": "pref"
    }
  }, [_vm._v("都道府県")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('th', [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": "city"
    }
  }, [_vm._v("市区町村")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('th', [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": "address1"
    }
  }, [_vm._v("番地")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('th', [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": "address2"
    }
  }, [_vm._v("建物名")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('th', [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": "mail"
    }
  }, [_vm._v("メールアドレス")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('th', [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": "tel"
    }
  }, [_vm._v("TEL")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('th', [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": "fax"
    }
  }, [_vm._v("FAX")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('th', [_c('label', [_vm._v("契約プラン / 支払い方法")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('th', [_c('label', [_vm._v("契約開始日")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('th', [_c('label', [_vm._v("契約終了予定日")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("変更後は契約内容変更をクリックしてください。"), _c('br'), _c('br'), _vm._v("不明な点につきましては、お手数ですが事務局までお問い合わせください。")])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-e4f8c016","hasScoped":true}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/dashboard/admin/Agreement.vue
// module id = 613
// module chunks = 1